<template>
    <aside class="product-search__aside">
        <div class="product-search__sticky">
            <button class="product-search__close" @click="$emit('update:active', false)">
                <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
            </button>

            <keep-alive>
                <div>
                    <Refinement title="Manufacturers" :params="{ attribute: 'manufacturer', searchable: true }" />
                    <Refinement title="Equipment Category" :params="{ attribute: 'equipmentCategory' }" />
                </div>
            </keep-alive>

            <!-- <div class="product-search__actions">
                <button class="btn btn--ghost btn--full" @click="sidebar = false"> Apply filters</button>
            </div> -->
        </div>
    </aside>
</template>

<script>
import Refinement from './Refinement.vue';

export default {
    components: {
        Refinement
    },
    
    props: {
        active: {
            type: Boolean,
            required: true
        }
    }
}
</script>